import { createApiSlice } from "@common";
import {
  CRUD_INQUIRY_SOURCE,
  GET_INQUIRY_SOURCE_BY_INQUIRY_ID
} from "@routes";

const apiConfig = [
  {
    name: "addInquirySource",
    method: "post",
    url: CRUD_INQUIRY_SOURCE,
    stateKey: "message",
  },
  {
    name: "getInquirySourceByInquiryId",
    method: "get",
    url: GET_INQUIRY_SOURCE_BY_INQUIRY_ID,
    stateKey: "details",
  },
];

const customReducers = {
  initialState: {
    data: [],
    details: [],
    additionalData: [],
  },
  reducers: {
    setAdditionalData: (state, action) => {
      state.additionalData = action.payload;
    },
  },
  extraReducers: {},
};

const { slice, thunks, actions } = createApiSlice(
  "inquirySource",
  apiConfig,
  customReducers
);
const inquirySourceSlice = slice;

export default inquirySourceSlice.reducer;

export const {
  addInquirySource,
  getInquirySourceByInquiryId,
} = thunks;

export const { rowSelect } = actions;
